<template>
	<div style="padding-top: -2px; margin-top: -2px">
		<vc-select-generic
			ref="sconceptService"
			autocomplete
			class="text"
			itemtext="ConName"
			itemvalue="ConID"
			:disabled="disabled"
			id="ConName"
			:value="value"
			:return-object="returnObject"
			@input="input($event)"
			:config="config"
			:label="label"
			:full="full"
			:autofocus="autofocus"
			:text="text"
			:clearable="clearable"
			:noDefault="noDefault"
			:outline="outline"
		></vc-select-generic>
	</div>
</template>

<script>
	import _sConceptService from "@/services/General/GenConceptServiceService.js"

	export default {
		name: "SelectConcepService",
		props : {
			autofocus: {
				type: Boolean,
				default: false,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			clearable: {
				type: Boolean,
				default: false,
			},
			value: null,
			text: {
				type: String,
				default: ""
			},
			label: {
				type: String,
				default: "",
			},
			returnObject: {
				type: Boolean,
				default: false,
			},
			noDefault: {
				type: Boolean,
				default: false,
			},
			full: {
				type: Boolean,
				default: false,
			},

			/* outlined: {
				type: Boolean,
				default: true
			}, */
		},
		data() {
			return {
				item: 0,
				val: "",
				items: [],
				config: {},
			}
		},
		watch: {
			value(value) {
				this.item = value;
			},
		},

		methods: {
			focus() {
				this.$refs.sarea.focus();
			},
			input(val) {
				this.$emit("input", val);
			},
		},

		created() {
			
			this.config = {
				url: _sConceptService.getUrlSearchConceptService(),
				title: this.label,
				params: {
					/* NtpID : this.$fun.getUserInfo().NtpID */
					/* search: '' */
				},
			};
		},
	}
</script>